export const API_URL = process.env.REACT_APP_API_URL;
export const STATIC_URL = process.env.REACT_APP_STATIC_URL;
export const IPDATA_KEY = process.env.REACT_APP_IPDATA_KEY || "dac12fae782984420bc7ed577ad6f60147ce7153dbd85f864ca0dac2"
export const COINBASE_API_KEY = "9YoQSZcWm86koUdE";
export const COINBASE_SECRET_KEY = "ofeFmD60EfqWHzsq8yJvowBd52e1ALeP";
export const GIFTSWAP_BENEFIT = process.env.REACT_APP_GIFTSWAP_BENEFIT
export const DEV = process.env.DEV